var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOilPump = function SvgOilPump(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482 481.615v-60h-40v-95h-30V195.701l46.403 8.182 10.419-59.088-332.011-58.543L156.1 23.651 24.15.385l-9.604 191.237 85.169 15.018 19.289-62.602 79.052 13.939-24.716 263.638H30v60H0v30h512v-30zm-199.909-150H233.07l44.943-43.493zm-8.438-90h-32.44l29.66-29.66zm-45.955-78.411 39.253 6.921.285 3.041-44.659 44.659zm-10.163 108.411h34.395l-37.827 36.607zm-8.438 90h46.585l-50.418 40.88zm20.221 60 56.886-46.124 4.324 46.124zm152.682-95h-30v95h-31.34l-23.071-246.088L382 190.411z"
  })));
};
export default SvgOilPump;